// extracted by mini-css-extract-plugin
module.exports = {"btn":"M3hv4Kjm3ZEjFzfdMFhyo","icon":"_1rGKqioLYQmTKu7uzSFFgP"};